import { Card } from 'shared/components/ui/Card';
import { Button } from 'shared/components/ui/Button';
import { Input } from 'shared/components/ui/Input';
import { cn } from 'shared/utils/cn';
import { ArenaOnboardingState } from 'modules/arena/onboarding/useArenaOnboarding';

export function StepCourts(state: ArenaOnboardingState) {
  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-ink-secondary">
        Cadastre as quadras da unidade e relacione cada uma aos esportes permitidos.
      </p>

      {state.courts.map((court) => (
        <Card key={court.id} className="p-4">
          <div className="flex items-center gap-3">
            <Input
              label="Nome da quadra"
              name={`court-name-${court.id}`}
              value={court.name}
              onChange={(event) => state.updateCourt(court.id, { name: event.target.value })}
              className="flex-1"
            />
            <Input
              label="Preço/hora (R$)"
              name={`court-price-${court.id}`}
              type="number"
              value={court.pricePerHour}
              onChange={(event) => state.updateCourt(court.id, { pricePerHour: Number(event.target.value) })}
              className="w-28"
            />
          </div>

          <div className="mt-3 flex flex-wrap gap-2">
            {state.selectedSportIds.map((sport) => {
              const isSelected = court.sportIds.includes(sport);

              return (
                <button
                  key={sport}
                  type="button"
                  onClick={() => state.toggleCourtSport(court.id, sport)}
                  className={cn(
                    'rounded-full border px-3 py-1 text-xs font-medium transition-colors',
                    isSelected
                      ? 'border-primary bg-accent-soft text-primary-dark'
                      : 'border-border text-ink-secondary hover:border-primary'
                  )}
                >
                  {sport}
                </button>
              );
            })}
          </div>

          {state.courts.length > 1 && (
            <button
              type="button"
              onClick={() => state.removeCourt(court.id)}
              className="mt-3 text-xs text-danger hover:underline"
            >
              Remover quadra
            </button>
          )}
        </Card>
      ))}

      <Button variant="ghost" onClick={state.addCourt}>
        + Adicionar quadra
      </Button>
    </div>
  );
}
